import script from "./NoteCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCreate.vue?vue&type=script&setup=true&lang=js"

import "./NoteCreate.vue?vue&type=style&index=0&id=1133c965&lang=css"

const __exports__ = script;

export default __exports__